import React from 'react'
interface IProps {}

//dont include for web, so empty  modal
const CodePushUpdatingModal: React.FC<IProps> = ({children}) => {
  return <></>
}

export default CodePushUpdatingModal
